import React from 'react'

interface SVGBackArrowProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
  opacity?: string;
}

const SVGBackArrow2 = ({ width = '24', height = '24', color = '#000', strokeWidth = '2', opacity = '0.5' }: SVGBackArrowProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={opacity}>
        <path
          d="M10 6L4 12M4 12L10 18M4 12H20"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default SVGBackArrow2
